import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import { getConfig } from '@gokrew/ui/runtime-config';

/**
 * My trainings stays behind the `ENABLE_TRAINING` build flag until the
 * module ships (spec D119); a bookmarked URL goes back to the dashboard.
 */
export function TrainingGuard({ children }: { children: ReactNode }) {
  if (!getConfig().ENABLE_TRAINING) return <Navigate to="/dashboard" replace />;
  return children;
}
